import { render, staticRenderFns } from "./manufacturers.vue?vue&type=template&id=797451c0"
import script from "./manufacturers.vue?vue&type=script&lang=js"
export * from "./manufacturers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports